import { Img, Text } from "components";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

const EmptyListOrder = (props) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <>
      <div className="flex flex-col items-center justify-center py-16 px-6 w-full">
        <Img
          className="h-[140px] w-auto mb-6 object-contain"
          src="/images/Emptybucket.png"
          alt="order-empty"
        />

        {/* ── Title ── */}
        <Text
          className="text-[20px] font-semibold text-black-900 font-['Inter'] leading-[28px] text-center mb-2 "
        >
          {props?.title || t("noOrdersYet") || "No orders yet"}
        </Text>

        {/* ── Subtitle ── */}
        <Text
          className="text-[14px] font-normal text-gray-500 font-['Inter'] leading-[22px] text-center max-w-[240px] mb-6"
        >
          {props?.paragraph || t("startExploringOurDeliciousCakes") || "Start exploring our delicious cakes and make your first order."}
        </Text>

        <button
          className="px-7 py-[11px] rounded-full text-[white] text-[14px] font-semibold font-['Inter'] tracking-wide cursor-pointer transition-opacity hover:opacity-90"
          style={{ backgroundColor: "#7B1A3C" }}
          onClick={() => navigate("/all-products")}
        >
          {props?.buttonText || t("browseCakes") || "Browse Cakes"}
        </button>

        {/*
          ── COMMENTED: old border box wrapper ──
          <div className="border border-gray-300 border-solid flex flex-col items-center justify-end
                          p-[57px] md:px-10 sm:px-5 rounded w-full">
            ...
          </div>
        */}

        {/*
          ── COMMENTED: old Button component (shopNow) ──
          <Button
            variant={"FillBlack"}
            size={"md"}
            className="w-[180px]"
            hover={true}
            hoverclass="bg-white-A700"
          >
            {t("shopNow")}
          </Button>
        */}
      </div>
    </>
  );
};

export default EmptyListOrder;